import { InjectionToken } from "@angular/core";
import { IAppConfig } from "../interfaces/app-config";

/**
 * This is the injection token for the app config
 */
export const APP_CONFIG = new InjectionToken<IAppConfig>("APP_CONFIG");
